import { switchUnstyledClasses } from '@mui/base/SwitchUnstyled';
import { SwitchUnstyled } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from 'theme';

const Root = styled('span')`
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
  cursor: pointer;

  &.${switchUnstyledClasses.disabled} {
    opacity: 0.4;
    cursor: not-allowed;
  }

  & .${switchUnstyledClasses.track} {
    background: ${theme.palette.primary.gray25};
    border-radius: 30px;
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
  }

  & .${switchUnstyledClasses.thumb} {
    display: block;
    width: 22px;
    height: 22px;
    top: 4px;
    left: 4px;
    border-radius: 16px;
    background-color: ${theme.palette.primary.white};
    position: relative;
    transition: all 200ms ease;
  }

  &.${switchUnstyledClasses.focusVisible} .${switchUnstyledClasses.thumb} {
    background-color: ${theme.palette.primary.gray25};
    box-shadow: 0 0 1px 8px rgba(0, 0, 0, 0.25);
  }

  &.${switchUnstyledClasses.checked} {
    .${switchUnstyledClasses.thumb} {
      left: 26px;
      top: 4px;
      background-color: #fff;
    }

    .${switchUnstyledClasses.track} {
      background: ${theme.palette.primary.darkBlue70};
    }
  }

  & .${switchUnstyledClasses.input} {
    cursor: inherit;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    margin: 0;
  }
`;

const ToggleSwitch = (props) => {
  return <SwitchUnstyled component={Root} {...props} />;
};

export default ToggleSwitch;
